<template>
	<div class="tw-flex prev-button" :class="{ 'disabled': disabled }">
		<div class="tw-flex tw-items-center">
			<div class="tw-text-right tw-mr-2">
				<p>Atrás</p>
				<p v-if="subTitle"><b>{{ subTitle }}</b></p>
			</div>
		</div>
		<v-btn
			@click="$emit('prevClick')"
			class="custom-button custom-button-icon tw-ml-3" color="primary"
			:disabled="disabled"
		>
			<v-icon>chevron_left</v-icon>
		</v-btn>
	</div>
</template>

<script>
export default {
	name: 'guideline-job-selector-prev-button',
	props: ['disabled', 'subTitle'],
};
</script>

<style lang='scss' scoped>
.prev-button {
	p {
		color: var(--app-color-primary);
		font-size: 12px;
		margin: 0;
		line-height: 12px;
	}
	&.disabled {
		p {
			color: #969696;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/guideline-model/jobs-manager/job-info-edition/guideline-job-selector-prev-button.vue